import { useCallback, useMemo, useState, useEffect } from 'react';
import { theme } from 'antd';
import { useAuth } from 'contexts/auth';

const useIndex = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < 992;
  });
  const { user, logout } = useAuth();

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const toggleCollapsed = useCallback(() => {
    setCollapsed((current) => !current);
  }, []);

  const openMenu = useCallback(() => {
    setShowMenu(true);
  }, []);

  const closeMenu = useCallback(() => {
    setShowMenu(false);
  }, []);

  const accountMenuClick = useCallback((e) => {
    if (e.key == 'logout') {
      logout();
      return;
    }
  }, [logout]);

  const accountMenu = useMemo(() => ({
    items: [
      {
        key: 'logout',
        label: 'Đăng xuất',
      },
    ],
    onClick: accountMenuClick,
  }), [accountMenuClick]);

  return {
    collapsed,
    toggleCollapsed,
    isMobile,
    showMenu,
    openMenu,
    closeMenu,
    user,
    colorBgContainer,
    borderRadiusLG,
    accountMenu,
  };
};

export default useIndex;